<template>
    <DialogRoot>
        <DialogTrigger>
            <button class="px-6 py-3 rounded-xl text-white bg-[#3c41e9] mx-auto">Justifier</button>
        </DialogTrigger>
        <DialogPortal>
            <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
            <DialogContent className="fixed w-[45%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white py-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                <DialogTitle class="m-0 text-[20px] font-normal px-[25px] text-black flex items-start justify-between">
                    Justifier {{ label.trim()[0] == "a" ? "l'" : "le " }}{{ label }}
                    <DialogClose>
                        <X :size="20" stroke-width="1.2" class="cursor-pointer"/>
                    </DialogClose>
                </DialogTitle>
                <DialogDescription class="text-black px-[25px] mt-4 text-[14px] font-extralight">
                    Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
                    avant soummition
                </DialogDescription>
                <form @submit.prevent="submitForm" class="px-[25px] text-black mt-4">
                    <div class="w-full flex flex-col items-start">
                        <label for="motif" class="font-extralight" >Motif de l'exception<span class="text-[#f44545]">*</span></label>
                        <select v-model="formdata.motif" name="motif" id="motif" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none bg-[#f9fafb] cursor-pointer">
                            <option value="">Choisissez le motif</option>
                            <option v-for="mtf in motifs" :key="mtf.id" :value="mtf.id"> 
                                {{mtf.text }} 
                            </option>
                        </select>
                    </div>
                    <div class="w-full flex flex-col items-start mt-2">
                        <label for="detail" class="font-extralight">Détails<span class="text-[#f44545]">*</span></label>
                        <textarea v-model="formdata.details" name="detail" id="" class="rounded-md bg-[#f9fafb] border p-5 h-[25vh] w-full"></textarea>
                    </div>
                    <div class="w-full flex justify-between mt-4 text-black">
                        <span class="font-extralight">Pièce jointe</span>
                        <label for="piece" class="font-light text-[#5357eb] cursor-pointer flex items-center gap-x-3">
                            <Plus :size="20" stroke-width="1.2"/>
                            Choisir un fichier
                        </label>
                        <input type="file" id="piece" @change="selectFiles" multiple accept="image/*,.pdf" class="hidden">
                    </div>
                    <div class="w-full p-3 flex flex-wrap gap-3 items-start">
                        <div v-for="(file,idx) in files" :key="file.lastModifiedDate" class="h-20 w-1/5 border rounded p-2 flex items-start justify-between relative">
                            <div :class="['w-[25%] h-full flex items-center justify-center text-[12px] text-white rounded',{'bg-[#5357eb]': getType(file.type) == 'IMG','bg-red-500': getType(file.type) != 'IMG'}]">
                                {{ getType(file.type) }}
                            </div>
                            <p class="text-[12px] w-[73%]">{{ formatText(file.name) }}</p>
                            <span v-on:click="removeFile(idx)" class="h-6 w-6 top-0 right-0 translate-x-[50%] translate-y-[-50%] cursor-pointer rounded-full absolute bg-red-500 flex items-center justify-center">
                                <X color="#fff" :size="12" />
                            </span>
                        </div>
                    </div>
                    <div className="w-full mt-4 gap-x-3 flex items-center justify-end">
                            <DialogClose asChild><button :disabled="asSend" class="px-8 py-3 text-[#797e91] transition-colors hover:bg-[#e9e9ec] rounded-md">Cancel</button></DialogClose>
                            <button type="submit" :disabled="asSend" class="px-8 py-3 bg-[#5357ec] text-white rounded-md">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-if="!asSend">Enregistrer</span>
                            </button>
                    </div>
                </form>
            </DialogContent>
        </DialogPortal>
    </DialogRoot>
</template>
<script>
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue';
import API from "@/service/API.js";
import Swal from 'sweetalert2';
import {
    X,
    Plus,
    Loader2
} from "lucide-vue-next"
export default {
    name:"JustifyException",
    components:{
        X,
        Loader2,
        DialogClose,
        DialogContent,
        Plus,
        DialogDescription,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger
    },
    props:["id_exception","motifs",'label'],
    data(){
        return {
            asSend:false,
            files:[],
            formdata:{
                motif:"",
                details:"",
            }
        }
    },
    methods:{
        jutifyException(){},
        resetForm(){
            this.formdata = {
                motif:"",
                details:"",
            }
        },
        selectFiles(e){
            if (!e.target.files?.[0]) return;
            this.files = [...e.target.files]
        },
        getType(type){
            const libelle = type.split("/")[0];
            return libelle == "image" ? "IMG" : "DOC"
        },
        formatText(libelle){
            return libelle.length >= 21 ? libelle.substring(0,20) + "..." : libelle;
        },
        removeFile(index){
            const tab = [...this.files];
            tab.splice(index,1);
            this.files = [...tab];
        },
        submitForm(){
            this.asSend = true;
            if(this.formdata.motif || this.formdata.details) {
               return Swal.fire('Erreur!!!!','Les champs sont obligatoires','error');
            }
            const formData = new FormData();
            formData.append("exception_id",this.id_exception);
            formData.append("motif_id",this.formdata.motif);
            formData.append("other_motif",this.formdata.details);
            if(this.files.length != 0){
                formData.append("file",this.files[0]);
            }
            API.post("askForJustification",formData)
            .then((response)=>{
                if(!response.data["status"]) throw Error(response.data["message"]);
                this.resetForm();
                Swal.fire('Succes','Exception justifié','succes')
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend = false;
            })
        }
    }
}
</script>